<template>
  <Modal
    v-model="shows"
    :title="title"
    ref="modal"
    draggable
    class-name="vertical-center-modal"
    :ok-text="$t('add.index.424326-0')"
    width="730"
    height="600"
    :loading='true'
    @on-ok="submit"
    @on-cancel="shows = false"
  >
    <Form
      ref="details"
      label-position="right"
      :label-width="120"
    >
      <Row span="24">
        <Col span="24">
          <FormItem :label="$t('add.index.424326-1')">
            <div v-if="data.type === 'add'" class="area-text" @click="selectAreaClick">
              <span v-if="areas.grade === 1">{{ areas.Cname }}</span>
              <span v-else-if="areas.grade === 2">{{
                areas.ProvinceName + areas.CityName + areas.Vname
              }}</span>
              <span v-else-if="areas.grade === 3">{{ areas.Sname }}</span>
              <span v-else>{{ $t('add.index.424326-2') }}</span>
            </div>
            <div v-else><span>{{areaText}}</span></div>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <area-model v-if="areas.grade === 1" ref="area" :areas="areas"></area-model>
    <town-model v-else-if="areas.grade === 2" ref="town" :areas="areas"></town-model>
    <village-model v-else-if="areas.grade === 3" ref="village" :areas="areas"></village-model>
    <city-model v-else ref="city"></city-model>
  </Modal>
</template>

<script>
import api from "../../../../../api/request.js";
import Cookies from "js-cookie";
import CityModel from "./city.vue";
import AreaModel from "./area.vue";
import TownModel from "./town.vue";
import VillageModel from "./village.vue";

const URL = {
  AddRoshCommunity: 'api/User/AddRoshCommunity', // 添加城市
  EditRoshCommunity: 'api/User/EditRoshCommunity', // 修改城市
  AddRoshVillage: 'api/User/AddRoshVillage', // 添加区域
  EditRoshVillage: 'api/User/EditRoshVillage', // 修改区域
  AddRoshSVillage: 'api/User/AddRoshSVillage', // 添加乡镇
  EditRoshSVillage: 'api/User/EditRoshSVillage', // 修改乡镇
  AddRoshZVillage: 'api/User/AddRoshZVillage', // 添加村
  EditRoshZVillage: 'api/User/EditRoshZVillage', // 修改村
}

export default {
  components: {
    CityModel,
    AreaModel,
    TownModel,
    VillageModel
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    data: {
      type: Object
    },
    area: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      areas: {},
      loading: true,
      areaText: this.$t('add.index.424326-2'),
    };
  },
  watch: {
    area(value) {
      this.areas = value;
    },
    'data.row'(value) {
      this.areas.grade = value.grade - 1;
      this.$nextTick(() => {
        switch (value.grade) {
          case 1:
            this.areaText = this.$t('add.index.424326-2')
            this.$refs.city.setData(value);
            break;
          case 2:
            this.areaText = value.Cname
            this.$refs.area.setData(value);
            break;
          case 3:
            this.areaText = value.ProvinceName + value.CityName + value.Vname
            this.$refs.town.setData(value);
            break;
          case 4:
            this.areaText = value.Sname
            this.$refs.village.setData(value);
            break;
          default:
            break;
        }
      })
      
    }
  },
  mounted() {},
  computed: {
    title() {
      return {
        add: this.$t('add.index.424326-3'),
        edit: this.$t('add.index.424326-4')
      }[this.data.type];
    },
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      }
    }
  },
  methods: {
    setArea(data) {
      this.areas = data;
    },
    // 选择区域
    selectAreaClick() {
      this.$emit("on-area");
    },
    async submit() {
      try {
        const { grade } = this.areas;
        let res = null
        this.$refs.modal.buttonLoading = false;
        switch (grade) {
          case 1:
            res = await this.$refs.area.submit();
            this.AddRoshVillage(res);
            break;
          case 2:
            res = await this.$refs.town.submit();
            this.AddRoshSVillage(res);
            break;
          case 3:
            res = await this.$refs.village.submit();
            this.AddRoshZVillage(res);
            break;
          default:
            res = await this.$refs.city.submit();
            this.AddRoshCommunity(res)
            break;
        }
        
      } catch (error) {
        console.log("handleSubmit -> error", error);
      }
    },

    // 城市提交
    AddRoshCommunity(data) {
      api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: this.data.type === 'edit' ? URL.EditRoshCommunity : URL.AddRoshCommunity,
					data: data,
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('Token')
					}
				}).then((res) => {
          this.shows = false;
					if (res.Success) {
						this.$Message['success']({
							background: true,
							content: res.Message
						});
            this.$emit('on-change', {...data, grade: 1})
					}
				})
    },

    // 区域提交
    AddRoshVillage(data) {
      api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url:  this.data.type === 'edit' ? URL.EditRoshVillage : URL.AddRoshVillage,
					data: data,
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('Token')
					}
				}).then((res) => {
          this.shows = false;
					if (res.Success) {
						this.$Message['success']({
							background: true,
							content: res.Message
						});
            this.$emit('on-change', {...data, grade: 2})
					}
				})
    },

    // 乡镇提交
    AddRoshSVillage(data) {
      api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: this.data.type === 'edit' ? URL.EditRoshSVillage : URL.AddRoshSVillage,
					data: data,
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('Token')
					}
				}).then((res) => {
          this.shows = false;
					if (res.Success) {
						this.$Message['success']({
							background: true,
							content: res.Message
						});
            this.$emit('on-change', {...data, grade: 3})
					}
				})
    },

    // 村提交
    AddRoshZVillage(data) {
      api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: this.data.type === 'edit' ? URL.EditRoshZVillage : URL.AddRoshZVillage,
					data: data,
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('Token')
					}
				}).then((res) => {
          this.shows = false;
					if (res.Success) {
						this.$Message['success']({
							background: true,
							content: res.Message
						});
            this.$emit('on-change', {...data, grade: 4})
					}
				})
    },

  }
};
</script>

<style scoped="scoped">
.area-text {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/area/add/index.vue